export default "__VITE_ASSET__CQ$JN6r6__"